<template>
    <div class="report__page">
        <h2>Report Details</h2>
        <ReportDetailsSelector 
            :details="customDetails"
            :is-compact="true"
        />
    </div>
</template>

<script>
import ReportDetailsSelector from './ReportDetailsSelector.vue';

export default {
    components: {
        ReportDetailsSelector
    },

    data() {
        return {
            customDetails: [
                { value: 'site_id', label: 'Site' },
                { value: 'asset_id', label: 'ID' },
                { value: 'name', label: 'Name' },
                { value: 'description', label: 'Description' },
                { value: 'asset_type', label: 'Type' },
                { value: 'category', label: 'Category' },
                { value: 'area', label: 'Area' },
                { value: 'location', label: 'Sub Area' },
                { value: 'make', label: 'Make' },
                { value: 'model', label: 'Model' },
                { value: 'maintenance_current_status', label: 'Last Report' },
                { value: 'maintenance_current_user', label: 'Last Report Attendant Name' },
                { value: 'maintenance_current_company', label: 'Last Report Attendant Company' },
                { value: 'maintenance_current_notes', label: 'Last Report Note' },
                { value: 'last_maintained_date', label: 'Last Maintained/Attendance Date' },
                { value: 'maintenance_schedule_start_date', label: 'Maintenance Schedule Start Date' },
                { value: 'maintenance_frequency', label: 'Maintenance Frequency' },
                { value: 'maintenance_status', label: 'Maintenance/Attendance Status' },
                { value: 'warranty_status', label: 'Warranty Status' },
                { value: 'warranty_warning', label: 'Warranty Warning Threshold' },
                { value: 'warranty_expiry_date', label: 'Warranty Expiry Date' },
                { value: 'lifecycle_status', label: 'Lifecycle Status' },
                { value: 'lifecycle_warning', label: 'Lifecycle Warning Threshold' },
                { value: 'lifecycle_expiry_date', label: 'Lifecycle Expiry Date' },
                { value: 'fault_status', label: 'Fault Status' },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;
    padding: 0.5rem;

    h2 {
        padding-left: 1rem;
        margin: 0;
    }
}
</style>